(function () {
    /**
     * @module searchAutocomplete
     */

    var searchAutocomplete = {};

    /**
     * Initialize the search autocomplete component
     */
    searchAutocomplete.init = function () {
        var containers = document.querySelectorAll(".qld__search-autocomplete");
        containers.forEach(function (container) {
            initAutocomplete(container);
        });
    };

    /**
     * Initialize autocomplete for a specific container
     */
    function initAutocomplete(container) {
        var config = JSON.parse(container.getAttribute("data-autocomplete-config"));
        var input = container.querySelector(".qld__search-autocomplete__input");
        var dropdown = container.querySelector(".qld__search-autocomplete__dropdown");
        var form = container.querySelector(".qld__search-form");

        if (!input || !dropdown || !config.collection) {
            console.warn("Autocomplete: Missing required elements or configuration");
            return;
        }

        if (config.active === "false") {
            return;
        }

        var debounceTimer;
        var currentRequest;
        var selectedIndex = -1;
        var suggestions = [];

        // Event listeners
        input.addEventListener("input", onInput);
        input.addEventListener("keydown", onKeydown);
        input.addEventListener("focus", onFocus);
        dropdown.addEventListener("mousedown", onDropdownMousedown);

        // Close dropdown when clicking outside
        document.addEventListener("click", function (e) {
            if (!container.contains(e.target) && isDropdownVisible()) {
                hideDropdown();
            }
        });

        function onInput(e) {
            var query = e.target.value.trim();
            clearTimeout(debounceTimer);

            if (query.length < (config.minLength || 3)) {
                hideDropdown();
                return;
            }

            debounceTimer = setTimeout(function () {
                fetchSuggestions(query);
            }, 300);
        }

        function onKeydown(e) {
            // Handle arrow keys - prevent page scrolling
            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                if (suggestions.length > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    // Show dropdown if not visible
                    if (!isDropdownVisible()) {
                        showDropdown();
                    }
                    // Navigate suggestions
                    if (e.key === "ArrowDown") {
                        selectedIndex = Math.min(selectedIndex + 1, suggestions.length - 1);
                    } else {
                        selectedIndex = Math.max(selectedIndex - 1, -1);
                    }
                    updateSelection();
                }
                return;
            }
            
            // Only handle other keys when dropdown is visible
            if (!isDropdownVisible()) {
                return;
            }

            if (e.key === "Enter") {
                e.preventDefault();
                if (selectedIndex >= 0) {
                    selectSuggestion(suggestions[selectedIndex]);
                } else {
                    submitForm();
                }
            } else if (e.key === "Escape") {
                e.preventDefault();
                hideDropdown();
            } else if (e.key === "Tab") {
                // Close dropdown when tabbing away - let tab work normally
                hideDropdown();
            }
        }

        function onFocus() {
            if (suggestions.length > 0 && input.value.trim().length >= (config.minLength || 3)) {
                showDropdown();
            }
        }

        function onDropdownMousedown(e) {
            // Prevent blur from firing before click registers
            e.preventDefault();
            
            var suggestion = e.target.closest(".qld__search-autocomplete__suggestion");
            if (suggestion) {
                var index = parseInt(suggestion.getAttribute("data-index"));
                selectSuggestion(suggestions[index]);
            }
        }

        function isDropdownVisible() {
            return dropdown.classList.contains("qld__search-autocomplete__dropdown--visible");
        }

        function showDropdown() {
            dropdown.classList.add("qld__search-autocomplete__dropdown--visible");
            dropdown.setAttribute("aria-hidden", "false");
            input.setAttribute("aria-expanded", "true");
        }

        function hideDropdown() {
            dropdown.classList.remove("qld__search-autocomplete__dropdown--visible");
            dropdown.setAttribute("aria-hidden", "true");
            input.setAttribute("aria-expanded", "false");
            selectedIndex = -1;
        }

        function fetchSuggestions(query) {
            if (currentRequest) {
                currentRequest.abort();
            }

            var url = config.server + "/s/suggest.json?" + new URLSearchParams({
                collection: config.collection,
                profile: config.profile || "_default",
                partial_query: query,
                min_length: config.minLength || 3,
                show: config.show || 10
            }).toString();

            currentRequest = new XMLHttpRequest();
            currentRequest.open("GET", url, true);

            currentRequest.onreadystatechange = function () {
                if (currentRequest.readyState === 4) {
                    if (currentRequest.status === 200) {
                        try {
                            var response = JSON.parse(currentRequest.responseText);
                            processSuggestions(response);
                        } catch (e) {
                            hideDropdown();
                        }
                    } else if (currentRequest.status !== 0) {
                        hideDropdown();
                    }
                    currentRequest = null;
                }
            };

            currentRequest.onerror = function () {
                hideDropdown();
                currentRequest = null;
            };

            currentRequest.send();
        }

        function processSuggestions(response) {
            suggestions = [];

            if (response && Array.isArray(response) && response.length > 0) {
                suggestions = response.map(function (item) {
                    return {
                        text: item.disp || item.key || item,
                        query: item.key || item,
                        category: item.cat || null
                    };
                });
                renderSuggestions();
                showDropdown();
            } else {
                hideDropdown();
            }
        }

        function renderSuggestions() {
            var html = '<div class="qld__search-autocomplete__header">Suggestions</div>';
            var currentCategory = null;

            suggestions.forEach(function (suggestion, index) {
                if (suggestion.category && suggestion.category !== currentCategory) {
                    html += '<div class="qld__search-autocomplete__category">' + 
                            escapeHtml(suggestion.category) + '</div>';
                    currentCategory = suggestion.category;
                }

                html += '<div class="qld__search-autocomplete__suggestion" data-index="' + index + '" role="option" tabindex="-1">' +
                        '<span class="qld__search-autocomplete__suggestion-text">' +
                        highlightMatch(suggestion.text, input.value) +
                        '</span></div>';
            });

            dropdown.innerHTML = html;
            selectedIndex = -1;
        }

        function updateSelection() {
            var items = dropdown.querySelectorAll(".qld__search-autocomplete__suggestion");
            
            items.forEach(function (el, index) {
                if (index === selectedIndex) {
                    el.classList.add("qld__search-autocomplete__suggestion--selected");
                    el.setAttribute("aria-selected", "true");
                    el.scrollIntoView({ block: "nearest" });
                } else {
                    el.classList.remove("qld__search-autocomplete__suggestion--selected");
                    el.setAttribute("aria-selected", "false");
                }
            });
        }

        function selectSuggestion(suggestion) {
            input.value = suggestion.query;
            hideDropdown();
            submitForm();
        }

        function submitForm() {
            // Clear honeypot
            var honeypot = form.querySelector(".qld__text-input--validation");
            if (honeypot) {
                honeypot.value = "";
                honeypot.removeAttribute("name");
            }

            if (typeof form.requestSubmit === "function") {
                form.requestSubmit();
                return;
            }

            form.submit();
        }

        function highlightMatch(text, query) {
            var escapedText = escapeHtml(text);
            var escapedQuery = escapeHtml(query);
            var regex = new RegExp("(" + escapeRegExp(escapedQuery) + ")", "gi");
            return escapedText.replace(regex, "<strong>$1</strong>");
        }

        function escapeHtml(text) {
            var div = document.createElement("div");
            div.textContent = text;
            return div.innerHTML;
        }

        function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
    }

    // Export
    window.QLD = window.QLD || {};
    window.QLD.searchAutocomplete = searchAutocomplete;

    // Initialize when DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () {
            QLD.searchAutocomplete.init();
        });
    } else {
        QLD.searchAutocomplete.init();
    }
})();
